import ChannelUnavailableModal from "../modals/ChannelUnavailableModal.tsx";
import {ReactNode} from "react";
import {useAuth} from "../../hooks/useAuth.tsx";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../stores/store.ts";
import {changeVideoAsync, playerActions} from "../player/playerSlice.ts";
import {modalsStateActions} from "../popups/modalsStateSlice.ts";
import {useModal} from "../../hooks/useModal.tsx";
import {InformationCircleIcon} from "@heroicons/react/24/outline";

export interface IPlayButtonChannel {
    ch_id: number,
    name: string,
    enabled: boolean
}

interface IProps {
    channel: IPlayButtonChannel,
    loggedInElem: ReactNode,
    loggedOutElem: ReactNode,
    withUnavailableModal: boolean,
    className?: string
    onClickExtra?: () => void,
}

const PlayButton = ({channel, className, loggedInElem, loggedOutElem, withUnavailableModal}: IProps) => {
    const _authService = useAuth();
    const _navigate = useNavigate();
    const _location = useLocation();
    const {showModal, closeModal} = useModal();
    const dispatch = useAppDispatch();
    const isChannelUnavailableModalOpen = useAppSelector(state => state.modalsState.isChannelUnavailableOpen);
    // const { openModal, openLoginModal, closeModal } = useContext(AppMainStateContext);

    const channelUnavailableModalContent = <div className={"flex flex-col justify-center md:justify-start h-full"}>
        <div className="px-4 flex flex-col items-center space-y-4 mt-2">
            <InformationCircleIcon className="w-10 h-10  md:w-10 md:h-10"/>
            <p className="">
                Kanał nie jest dostępny w serwisie Beskid Media GO
            </p>
        </div>
    </div>

    const handlePlayButtonClick = () => {
        const path = _location.pathname;
        dispatch(playerActions.setInitialRun(false));
        if (path.startsWith("/kanaly-tv/") && path.endsWith("/player")) {
            dispatch(changeVideoAsync({chId: channel.ch_id}));
            dispatch(modalsStateActions.setIsRequestToCloseModalSent(true));
        } else {
            _navigate(`/kanaly-tv/${channel.ch_id}/player`);
        }
    }
    return (
        <>
            {channel.enabled ?
                _authService.token ?
                    <button
                        className={className}
                        onClick={handlePlayButtonClick}
                    >
                        {loggedInElem}
                    </button>
                    :
                    <Link
                        to={`/logowanie?redirectTo=/kanaly-tv/${channel.ch_id}/player`}
                        className={className}
                        onClick={() => {
                            openLoginModal(false);
                            dispatch(playerActions.setInitialRun(false));
                        }}
                        title={channel.name}
                    >
                        {loggedOutElem}
                    </Link>
                :
                <button
                    onClick={() => {
                        showModal(null, channelUnavailableModalContent, "16%");
                        // openModal();
                        // dispatch(modalsStateActions.setIsChannelUnavailableOpen(true))
                        // dispatch(playerActions.setInitialRun(false));
                    }}
                    className={className}
                    title={channel.name}
                >
                    {loggedInElem}
                </button>
            }
            {/*withUnavailableModal obejscie dla strony epgPage, jezeli uzyje tam tego modalu to modal bezie mrugac i nie bedzie dalo sie go zamknac. Problem spowodowany przez react virtualizer (zastosowano lokalny modal EpgPageChannelUnavailableModal). Wszedzie indziej dziala bez problemu*/}
            {withUnavailableModal &&
                <ChannelUnavailableModal isOpen={isChannelUnavailableModalOpen}
                                         onClose={() => {
                                             dispatch(modalsStateActions.setIsChannelUnavailableOpen(false));
                                             closeModal();
                                         }}/>
            }
        </>
    );
};

export default PlayButton;